module.exports = __webpack_public_path__ + "static/media/muehle_egg.4d01e767.jpg";